export async function getPreferredImmersiveSessionMode(xr) {
  if (!xr?.isSessionSupported) {
    return null;
  }

  // Both entry routes use AR when available so scenery can be hidden without
  // ending the active session. Probe independently: an AR rejection isn't a VR failure.
  for (const mode of ["immersive-ar", "immersive-vr"]) {
    try {
      if (await xr.isSessionSupported(mode)) return mode;
    } catch (_) { /* Continue to the next supported mode. */ }
  }

  return null;
}

export function getXrEnterLabel(sessionMode) {
  return "Enter XR";
}
